(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    function (error) {
      if (!error) {
        try {
          window.Osano.cm.ready('shopify');
        } catch (error) {
          console.error('Osano must be loaded before initializing the Shopify API.');
        }
      }
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .then(() => {
            this.querySelectorAll('picture').forEach((pic) => {
              pic.querySelectorAll('source').forEach((s) => {
                if (s.dataset.srcset) {
                  s.srcset = s.dataset.srcset;
                  s.removeAttribute('data-srcset');
                }
              });
              pic.classList.add('loaded');
            });
            setTimeout(() => {
              if (this.querySelector('.scroll-animation')) {
                this.querySelector('.scroll-animation').classList.add('scroll-animation--active');
              }

              // Mobile product card slider
              document.querySelectorAll('.product-card__media a').forEach((container) => {
                container.addEventListener('scroll', () => {
                  const slides = container.querySelectorAll('div');
                  if (slides.length < 2) return; // Ensure there is a second slide

                  const secondSlide = slides[1]; // The second slide
                  const containerScrollLeft = container.scrollLeft;
                  const slideLeft = secondSlide.offsetLeft;
                  const containerWidth = container.clientWidth;

                  // Check if second slide is centered within the viewport
                  if (
                    containerScrollLeft >= slideLeft - containerWidth / 2 &&
                    containerScrollLeft < slideLeft + containerWidth / 2
                  ) {
                    container
                      .closest('.product-card__media')
                      .querySelector('.media-pagination')
                      .classList.add('second-slide-active');
                  } else {
                    container
                      .closest('.product-card__media')
                      .querySelector('.media-pagination')
                      .classList.remove('second-slide-active');
                  }
                });
              });
            }, 500);
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 100px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
